export const LOGO_URL =
  "https://static.prod-images.emergentagent.com/jobs/dc1505f6-572a-49ba-b77f-3ffcf5922a44/images/1806ba915ea82e645c174ffe4c397483ee274f0fafb9c2246f572c48ef687dc2.jpeg";
export const HERO_URL =
  "https://static.prod-images.emergentagent.com/jobs/dc1505f6-572a-49ba-b77f-3ffcf5922a44/images/ef4870685e71cc0bc039df220ec99ff8615fad61f8b132e132d83e7dc26ddf05.jpeg";
